module.exports = __webpack_public_path__ + "img/dview_tuopubianji.c0f2d88b.jpg";